import React from 'react';
import { connect } from 'react-redux';
import { mediaPickerActions } from '../../store';
import MediaPickerLoadMoreCard from '../../common/MediaPickerLoadMoreCard';
import MediaPickersConstants from '../../MediaPickersConstants';

const LogoAssetImagesLoadMoreCard = ({
    logoAssetsPageNumber,
    logoAssetsLoading,
    galleryCardWidth,
    galleryCardHeight,
    loadUserLogoAssets
}) => {
    const onLoadMoreButtonClick = () => {
        loadUserLogoAssets(logoAssetsPageNumber + 1, MediaPickersConstants.LOGO_ASSETS_PER_PAGE);
    }

    return (
        <MediaPickerLoadMoreCard
            key={'load-more-button'}
            onLoadMoreButtonClick={onLoadMoreButtonClick}
            isLoading={logoAssetsLoading}
            galleryCardWidth={galleryCardWidth}
            galleryCardHeight={galleryCardHeight}
        />
    );
};

const mapStateToProps = (state) => {
    const {
        logoAssetsPageNumber,
        logoAssetsLoading
    } = state.mediaPicker;

    return {
        logoAssetsPageNumber,
        logoAssetsLoading
    };
}

const mapDispatchToProps = (dispatch) => {
    const setProperty = (key, value) => dispatch(mediaPickerActions.setProperty(key, value));
    const loadUserLogoAssets = (pageNumber, itemsPerPage) => dispatch(mediaPickerActions.loadUserLogoAssets(pageNumber, itemsPerPage));

    return {
        setProperty,
        loadUserLogoAssets
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LogoAssetImagesLoadMoreCard);